import gql from 'graphql-tag';

export default gql`
query localGovtQuery($filter: JSON) {
  localGovtQuery(filter: $filter) 
}
`;
